<script setup>
import { useI18n } from 'vue-i18n';
import SalesDetailPartyDocuments from './SalesDetailPartyDocuments.vue';
import SalesDetailPersonProfile from './SalesDetailPersonProfile.vue';

const props = defineProps({
  representative: { type: Object, required: true },
  transactionId: { type: [Number, String], required: true },
  summary: { type: Boolean, default: false },
  profileTitle: { type: String, default: '' },
  documentsTitle: { type: String, default: '' },
});

const { t } = useI18n();
</script>

<template>
  <section
    :class="
      props.summary
        ? 'grid gap-4'
        : 'grid gap-4 rounded-lais-sm border border-lais-border-soft bg-lais-bg-soft p-4'
    "
    :aria-label="representative.display_name"
  >
    <p v-if="!props.summary" class="text-sm font-semibold text-lais-text">
      {{ t('SALES.DETAIL.REPRESENTATIVE') }}
      {{ t('SALES.COMMON.SEPARATOR') }}
      {{ representative.display_name }}
    </p>
    <SalesDetailPersonProfile
      :party="representative"
      :summary="props.summary"
      :card-title="props.profileTitle"
    />
    <SalesDetailPartyDocuments
      :documents="representative.documents || []"
      :party-id="representative.id"
      :transaction-id="transactionId"
      :summary="props.summary"
      :card-title="props.documentsTitle"
    />
  </section>
</template>
